import { PopUpComponent } from '../../../components/PopUpComponent';
import { InputComponent } from '../../../components/InputComponent';
import { IInventoryProvider } from '../../../interfaces/service/InventoryServiceManagerInterface';
import { ActivePopUp } from '../../../interfaces/interfaceInventory';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

interface IRechargeCounterModal {
  serviceInventory: IInventoryProvider;
}

export const RechargeCouterModal = (props: IRechargeCounterModal) => {
  const { serviceInventory } = props;

  const bodyContent = () => {
    const templateInput = (data: any) => {
      let inputValue =
        serviceInventory.counterData.find(
          (currentData: any) => currentData.counterTypeId === data.Id
        )?.amount || '';

      return (
        <InputComponent
          id={data.Id}
          type="number"
          name={data.Address}
          placeholder={`Cantidad para ${data.Address}`}
          value={inputValue}
          onChange={serviceInventory.editCounterModalValues}
        />
      );
    };
    var table = (
      <DataTable
        value={serviceInventory.counters}
        scrollable={true}
        scrollHeight="500px"
        emptyMessage="Sin resultados">
        <Column field="Address" header="Dirección" className="w-2"></Column>
        <Column field="ammount" header="Cantidad" body={templateInput}></Column>
      </DataTable>
    );

    return table;
  };

  return (
    <PopUpComponent
      header={`Agregar contadores para ${serviceInventory.popUpHeader}`}
      showPopUp={
        serviceInventory.activePopUp === ActivePopUp.RechargeCounterModal &&
        serviceInventory.showPopUp
      }
      onSubmit={() => serviceInventory.getRechargeConterResponse()}
      onClosePopUp={() => serviceInventory.closePopUp()}
      footerOnlyCancel={serviceInventory.counters.length > 0 ? false : true}
      footer={true}
      body={bodyContent()}
    />
  );
};
